import { FCNC } from '../FCNC';
import newLogo from './newLogo.svg';

/** TODO: optional dedicated white/light SVG if filter-based treatment is not enough. */
export const NewLogoWhite: FCNC = () => {
    return (
        <img
            src={newLogo}
            alt="HighRadius"
            style={{
                height: '44px',
                width: 'auto',
                filter: 'brightness(0) invert(1)',
            }}
            role="img"
        />
    );
};
